import { LogIn, Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const logoUrl = "/right-hire-mark.webp";

const links = [
  ["Home", "/"],
  ["About", "/about"],
  ["Employers", "/employers"],
  ["Job Seekers", "/job-seekers"],
  ["Current Vacancies", "/vacancies"],
  ["Industries", "/industries"],
  ["Contact", "/contact"],
];

export const SiteHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { user } = useAuth();
  const accountPath = user?.role === "candidate" ? "/candidate-portal" : "/admin";

  return (
    <header className="site-header" data-testid="site-header">
      <div className="site-header-inner">
        <Link className="brand-link" to="/" data-testid="brand-home-link">
          <img className="brand-logo" src={logoUrl} alt="Right Hire Personnel RH mark" data-testid="brand-logo" />
          <span className="brand-wordmark" data-testid="brand-wordmark">
            <strong>RIGHT HIRE</strong>
            <small>PERSONNEL</small>
          </span>
        </Link>
        <nav className="desktop-nav" aria-label="Primary navigation" data-testid="desktop-navigation">
          {links.map(([label, path]) => (
            <NavLink className="nav-link" to={path} key={path} data-testid={`nav-${label.toLowerCase().replaceAll(" ", "-")}`}>
              {label}
            </NavLink>
          ))}
        </nav>
        <Link className="nav-cta" to="/employers" data-testid="header-request-staff-button">
          Request Staff
        </Link>
        <Link className="nav-login" to={user ? accountPath : "/login"} data-testid="header-login-link">
          <LogIn size={14} />
          {user ? "My account" : "Sign in"}
        </Link>
        <button
          className="menu-button"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-button"
        >
          {isOpen ? <X size={21} /> : <Menu size={21} />}
        </button>
      </div>
      {isOpen && (
        <nav className="mobile-nav" aria-label="Mobile navigation" data-testid="mobile-navigation">
          {links.map(([label, path]) => (
            <NavLink className="mobile-nav-link" to={path} key={path} onClick={() => setIsOpen(false)} data-testid={`mobile-nav-${label.toLowerCase().replaceAll(" ", "-")}`}>
              {label}
            </NavLink>
          ))}
          <Link className="mobile-nav-link" to={user ? accountPath : "/login"} onClick={() => setIsOpen(false)} data-testid="mobile-nav-dashboard">
            {user ? "My account" : "Recruiter sign in"}
          </Link>
        </nav>
      )}
    </header>
  );
};

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="footer-grid">
      <div>
        <p className="eyebrow">RIGHT HIRE PERSONNEL</p>
        <p className="footer-statement">The Right Hire. Every Time.</p>
      </div>
      <div>
        <p className="footer-heading">FOR BUSINESS</p>
        <Link to="/employers" data-testid="footer-request-staff-link">Request staff</Link>
        <Link to="/industries" data-testid="footer-industries-link">Industries</Link>
      </div>
      <div>
        <p className="footer-heading">FOR WORKERS</p>
        <Link to="/job-seekers" data-testid="footer-register-link">Register with us</Link>
        <Link to="/vacancies" data-testid="footer-vacancies-link">Current vacancies</Link>
      </div>
      <div>
        <p className="footer-heading">ADELAIDE SOUTH AUSTRALIA</p>
        <a href="tel:+61432143111" data-testid="footer-phone-link">0432 143 111</a>
        <a href="mailto:paul@rhpersonnel.com.au" data-testid="footer-email-link">paul@rhpersonnel.com.au</a>
        <a href="https://righthirepersonnel.com.au" target="_blank" rel="noreferrer" data-testid="footer-website-link">righthirepersonnel.com.au</a>
        <Link to="/contact" data-testid="footer-contact-link">Send an enquiry</Link>
      </div>
    </div>
    <div className="footer-bottom" data-testid="footer-copyright">
      <div className="footer-bottom-brand" data-testid="footer-bottom-brand">
        <img src="/right-hire-logo.webp" alt="Right Hire Personnel" className="footer-bottom-logo" data-testid="footer-bottom-logo" />
        <span>© {new Date().getFullYear()} Right Hire Personnel</span>
      </div>
      <a href="https://nexadigital.com.au" target="_blank" rel="noreferrer" data-testid="footer-nexa-digital-link">
        Built by Nexa Digital
      </a>
    </div>
  </footer>
);